import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

const DOCUMENT_GROUPS_ENDPOINT = "v2/content/documentgroups";
const LOYALTY_CONTENT_MEMBER_LEVELS_ENDPOINT = `${DOCUMENT_GROUPS_ENDPOINT}/loyalty-member-level`;
const LOYALTY_CONTENT_EARN_POINTS_ENDPOINT = `${DOCUMENT_GROUPS_ENDPOINT}/loyalty-earn-points`;

@Injectable({
	providedIn: "root",
})
export class LoyaltyContentConfig {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getMemberLevelsEndpoint(): string {
		return this.configService.get(
			(x) => x.common.loyaltyContent.endpoints!.memberLevels,
			LOYALTY_CONTENT_MEMBER_LEVELS_ENDPOINT
		);
	}

	getEarnPointsEndpoint(): string {
		return this.configService.get(
			(x) => x.common.loyaltyContent.endpoints!.earnPoints,
			LOYALTY_CONTENT_EARN_POINTS_ENDPOINT
		);
	}
}
